/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { PatternFormat } from 'react-number-format';

const Mask = (props, ref) => {
  const { onChange, ...other } = props;

  return (
    <PatternFormat
      {...other}
      getInputRef={ref}
      format="###-##-####"
      onValueChange={(values) => onChange(values.formattedValue)}
    />
  );
};

export default forwardRef(Mask);
